export default __webpack_public_path__ + "static/media/ph.ffed9634.svg";